import Control from 'ol/control/Control';
import './ki-station-download-button';
/*
 * station download layers.
 * */
export default class StationDownloadLayer extends Control {
  constructor(options = {}) {
    options = { visible: true, ...options };
    options.element = document.createElement('ki-station-download-button');
    options.element.selectedStations = options.selectedStations;
    super(options);
    this.label = options.label;
    this.setVisible(options.visible);
    this.setProperties({
      name: options.name,
      displayInLayerControl: options.displayInLayerControl,
      group: options.group,
    });
  }

  set label(label) {
    this.element.label = label;
  }

  set options(options) {
    this.element.options = options;
  }

  setMap(map) {
    super.setMap(map);
  }

  // move a parent class
  setVisible(flag) {
    this._visible = flag;
    this.element.classList.toggle('hide', !flag);
  }

  getVisible() {
    return this._visible;
  }
}
